import { render, staticRenderFns } from "./ViewBallot.vue?vue&type=template&id=c8d7d79c&"
import script from "./ViewBallot.vue?vue&type=script&lang=js&"
export * from "./ViewBallot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports